import type { Plan, PlanWarning } from '../plan';
import type { LateNeed } from '../shopping';

/**
 * DE: Hinweise „Läden zu“ neu setzen: je Tag die Produkte, die vor dem ersten Einkauf fehlen.
 * EN: Reset the "shops closed" warnings: per day the products missing before the first trip.
 */
export function withClosedShopWarnings(plan: Plan, late: readonly LateNeed[]): Plan {
  const byDate = new Map<string, Set<string>>();
  for (const need of [...late].sort((a, b) => a.date.localeCompare(b.date))) {
    byDate.set(need.date, (byDate.get(need.date) ?? new Set()).add(need.productId));
  }
  const closed: PlanWarning[] = [...byDate].map(([date, productIds]) => ({
    code: 'shops-closed',
    date,
    productIds: [...productIds],
  }));
  const others = plan.warnings.filter((warning) => warning.code !== 'shops-closed');
  return { ...plan, warnings: [...others, ...closed] };
}
